import { render } from "./ProductStockBalance.vue?vue&type=template&id=3c879052&scoped=true"
import script from "./ProductStockBalance.vue?vue&type=script&lang=js"
export * from "./ProductStockBalance.vue?vue&type=script&lang=js"

import "./ProductStockBalance.vue?vue&type=style&index=0&id=3c879052&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c879052"]])

export default __exports__